import createRoute        from '@widesk-ui/tools/createRoute';
import EntertainmentModel from '@models/shop/EntertainmentModel';

export default createRoute.splitView('/entertainments', 'shop', 'EntertainmentSplitView', EntertainmentModel.localize('plural'));
